export default "__VITE_ASSET__DAsZr1mR__"